import React from 'react';
import DataTable from 'react-data-table-component';

import useReportTemplates from 'components/Common/ReportTemplates/Hooks/useReportTemplates';
import columns from './columns';

export default function Table() {
  const [reportTemplates, refresh] = useReportTemplates();

  const onDelete = () => {
    refresh();
  };

  return (
    <div className="datatable-style">
      <DataTable
        title=""
        columns={columns({
          onDelete,
        })}
        data={reportTemplates || []}
        noDataComponent={(
          <div className="mt20">
            {reportTemplates == null
              ? 'Please, wait ...'
              : 'No matching records found'}
          </div>
          )}
        persistTableHead
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: 'All',
        }}
      />
    </div>
  );
}
